document.addEventListener('DOMContentLoaded', () => {
  let slider_speed = document.querySelector('.promo-bar__message').dataset.slideTime;
  const promoSlider = new Swiper('.promo-bar__message', {
    slidesPerView: 1,
    loop: true,
    speed: 500,
    grabCursor: true,
    effect: 'fade',
    preventClicks: false,
    preventClicksPropagation: false,
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: slider_speed,
    }
  });
 
});
